import { defineStore } from 'pinia'

import JsonApiHelper from '~/helpers/json-api-helper'
import type { SpecialityData } from '~/types/specialities'

export const messages = {
  failedToGetSpecialities: 'Не удалось получить специальности.'
}

type State = {
  specialitiesData: SpecialityData[]
  filter: {
    excludeIds: string[]
    query: string
  }
  isDataLoading: boolean
}

const initialState = (): State => ({
  specialitiesData: [],
  filter: {
    excludeIds: [],
    query: ''
  },
  isDataLoading: false
})

export const useSpecialitiesStore = defineStore('specialities', {
  state: () => initialState(),
  getters: {
    getSpecialities: (state: State) => state.specialitiesData
  },
  actions: {
    addExcludeId (id: string): void {
      this.filter.excludeIds.push(id)
    },
    clearFilter (): void {
      this.filter.excludeIds = []
      this.filter.query = ''
    },
    clearSpecialities (): void {
      this.specialitiesData = []
    },
    dispose (): void {
      this.clearFilter()
      this.clearSpecialities()
    },
    removeExcludeId (id: string): void {
      const index = this.filter.excludeIds.indexOf(id)
      this.filter.excludeIds.splice(index, 1)
    },
    async fetchSpecialities (query?: string, excludeIds?: []): Promise<void> {
      const { $apiHelper, $toast } = useNuxtApp()
      const filter = {
        excludeIds: excludeIds || this.filter.excludeIds,
        query: query || this.filter.query
      }

      this.isDataLoading = true

      try {
        const response = await $apiHelper.specialities.getSpecialities({ filter }) as any
        const { data } = JsonApiHelper.denormalizeResponse(response) as any

        this.specialitiesData = data
      } catch (error) {
        console.error(error)

        $toast.error(messages.failedToGetSpecialities)
      }

      this.isDataLoading = false
    }
  }
})
